import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { OverridableComponent } from '@mui/material/OverridableComponent';

import type { SvgIconTypeMap } from '@mui/material';

import { cardContent } from './utils';

interface ICardContent {
  Icon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  title: string;
  active: boolean;
  setFilter: (filter: string) => void;
  filter: string;
}

interface IButtonsSection {
  setFilter: (filter: string) => void;
  filter: string;
}

const ButtonsSection = ({ setFilter, filter }: IButtonsSection) => {
  return (
    <Grid
      container
      spacing={2}
      size={12}
      sx={{
        display: 'flex',
        flexDirection: { xxs: 'column', md: 'row' },
        mb: '1rem',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {cardContent.map((card) => (
        <Cards
          key={card.id}
          Icon={card.icon}
          title={card.title}
          filter={card.filter}
          active={filter === card.filter}
          setFilter={setFilter}
        />
      ))}
    </Grid>
  );
};

export default ButtonsSection;

const Cards = ({ Icon, title, active, setFilter, filter }: ICardContent) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{
        cursor: 'pointer',
        outline: active ? `1px solid ${theme.palette.primary.main}` : 'none',
        borderRadius: '1rem',
        padding: '1.75rem 1.5rem',
        width: '15rem',
        minWidth: '15rem',
        margin: '1rem',
        backgroundColor: 'white',
        boxShadow: theme.customShadows.z4,
        ':hover': {
          outline: `1px solid ${theme.palette.primary.main}`,
        },
      }}
      onClick={() => setFilter(filter)}
    >
      <Icon color="primary" />
      <span>{title}</span>
    </Box>
  );
};
